import { render, staticRenderFns } from "./UiComponentFilter.vue?vue&type=template&id=4113b7f3"
import script from "./UiComponentFilter.vue?vue&type=script&lang=ts"
export * from "./UiComponentFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports